export const STUDENT_EMAIL_DOMAIN = import.meta.env.VITE_STUDENT_EMAIL_DOMAIN;

export const LINK_API_BASE_URL = import.meta.env.VITE_LINK_BASE_URL;
export const CONNECT_API_BASE_URL = LINK_API_BASE_URL + "/connect";
export const MEAL_BOOKINGS_API_BASE_URL = LINK_API_BASE_URL + "/meal_bookings";
export const SLOT_BOOKINGS_API_BASE_URL = LINK_API_BASE_URL + "/slot_bookings";

export const SURVEY_API_BASE_URL = CONNECT_API_BASE_URL + "/surveys";

export const PC_STATIC = import.meta.env.VITE_PC_STATIC;
export const PRIVACY = PC_STATIC + "/privacy";
export const TERMS = PC_STATIC + "/terms";

export const SESSION_AGE = import.meta.env.VITE_SESSION_AGE;
export const AUTH_MODAL_AGE = import.meta.env.VITE_AUTH_MODAL_AGE;
export const IDLE_TIMEOUT = import.meta.env.VITE_IDLE_TIMEOUT;

export const SUPPORT_EMAIL = "support@payandconnect.co.za";

export const USER_COLLECTION = "users";

export const ACCOUNTS_VOUCHERS = "voucher";
export const ACCOUNTS_GENERAL = "general";

export const TX_TRANSFER = "transfer";
export const TX_WITHDRAWAL = "withdrawal";
export const TX_VOUCHER = "voucher";
export const TX_REFUND = "refund";
export const TX_DEPOSIT = "deposit";

export const STUDENT = "student";
export const MERCHANT = "merchant";
export const SCANNER = "scanner";
export const KITCHEN = "kitchen";

export const KEY_MEAL_BOOKINGS = "meal_bookings";
export const KEY_MEAL_COLLECTIONS = "meal_collection_nomination";
export const KEY_SURVEYS = "surveys";

export const SENT = "sent";
export const RECEIVED = "received";

export const STATUS_COMPLETE = "Complete";
export const STATUS_FAILED = "Failed";
export const STATUS_PROCESSING = "Processing";
export const STATUS_INITIALIZED = "Initialized";
export const STATUS_PENDING = "Pending";
export const STATUS_CANCELLED = "Cancelled";

export const STATUS_PAGE_URL =
  "https://zc0kcyzv912v.statuspage.io/embed/script.js";
export const ZENDESK_URL =
  "https://static.zdassets.com/ekr/snippet.js?key=18e6f6bb-ac61-407c-99f1-ce61d309c0c7";
